import { type StrictNullable } from "@pasta/box-v2";
import { defineStore } from "pinia";

export const useSimpleFeatureStore = defineStore("features", {
  persist: true,
  state: () => ({
    privateMessage: {
      enabled: false,
      audio: {
        enabled: false,
        maxDuration: 10 * 60 * 1_000, // 10min
      },
    },
    tmpDisableLinksRefacto: true,
    signaturePosFullResize: false,
    pades: {
      enabled: false,
      webappCert: null as StrictNullable<string>,
    },
    favoriteUsers: {
      enabled: false,
      privateMessageMax: 5,
    },
    docTrashExpiry: 20,
    linkShortenerEnabled: false,
    linksDuration: 30 * 24 * 60 * 60, // 30 days, expressed in seconds,
    uiStates: {
      ccModal: {
        alertOpened: true,
      },
    },
  }),
  actions: {
    setPrivateMessageEnabled(enabled: boolean, audio: { enabled: boolean; maxDuration: number }) {
      this.privateMessage.enabled = enabled;
      this.privateMessage.audio = audio;
    },
    setTmpDisableLinksRefacto(value: boolean) {
      this.tmpDisableLinksRefacto = value;
    },
    setSignaturePosFullResize(value: boolean) {
      this.signaturePosFullResize = value;
    },
    setPadesEnabled(enabled: boolean) {
      this.pades.enabled = enabled;
    },
    setPadesWebappCert(cert: string) {
      this.pades.webappCert = cert;
    },
    setFavoriteUsers(value: { enabled: boolean; privateMessageMax: number }) {
      this.favoriteUsers = value;
    },
    setDocTrashExpiry(expiry: number) {
      this.docTrashExpiry = expiry;
    },
    setLinkShortenerEnabled(value: boolean) {
      this.linkShortenerEnabled = value;
    },
    setLinksDuration(value: number) {
      this.linksDuration = value;
    },
  },
});
